var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.size},[_c('button',{staticClass:"btn btn-question py-2 px-1 focus:outline-none truncate",class:{'active':_vm.active},attrs:{"disabled":!_vm.available},on:{"click":_vm.emitValue}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }